const PROFILES = [
  {
    name: "Cody D. Thrash",
    role: "Co-founder · Writer",
    image: "https://customer-assets.emergentagent.com/job_writer-shop-3/artifacts/bsbokoo1_CODY%20PORTRAIT.PNG",
    bio: [
      "On March 13, 2017, my life was forever changed when I received the Holy Ghost, ending an eleven-year addiction to alcohol and beginning a new life in Christ.",
      "Since then, I have devoted myself to studying and teaching God's Word, discipling believers, and providing Christian counseling. For nearly a decade, my passion has been helping people grow in biblical truth, strengthen their walk with God, and experience the transforming power of Jesus Christ.",
      "My mission is simple: to help others find hope, healing, and spiritual growth through the truth of God's Word.",
    ],
    quote: "There is a God and I am not Him.",
    accent: "var(--ember)",
  },
  {
    name: "Samantha N. Thrash",
    role: "Co-founder · Writer",
    image: "https://customer-assets.emergentagent.com/job_writer-shop-3/artifacts/4qwpku99_SAM%20PORTRAIT.PNG",
    bio: [
      "In September 2016, my life was forever changed when I received the Holy Ghost. In that moment, the Lord healed me from anxiety, depression, anger, and deep emotional wounds, replacing fear with peace and giving me a new life in Christ.",
      "Since then, I have found great joy in studying and teaching God\u2019s Word, praying with souls in the altar, and writing about the truths and lessons the Lord places on my heart. Every opportunity to encourage someone in their walk with God is a reminder of His incredible faithfulness and grace.",
      "The Lord has also blessed our family with three beautiful, healthy daughters: Evelyn, JoAnna, and Rebekah. Watching them grow in the knowledge and love of Christ is one of my greatest joys.",
      "God has been so good to us, and my prayer is that every word I speak, and every life I touch, will point others to the hope, healing, and transforming power found in Jesus Christ.",
    ],
    quote: "The faithfulness of God is the story of my life.",
    accent: "var(--gold)",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      {/* TITLE */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="overline mb-4">Two writers · one ministry</div>
        <h1 className="font-serif-display tracking-[-0.045em] leading-[0.88]" style={{ color: "var(--ink)" }}>
          <span className="block text-5xl sm:text-7xl lg:text-9xl">CODY</span>
          <span className="block text-5xl sm:text-7xl lg:text-9xl">
            <span className="font-serif-display-italic" style={{ color: "var(--ember)" }}>&amp;</span> SAMANTHA<span style={{ color: "var(--ember)" }}>.</span>
          </span>
        </h1>
        <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed" style={{ color: "var(--ink-2)" }}>
          We're a husband and wife serving together in ministry — committed to discipleship and biblical and pastoral counseling.
          Our mission is to help people find hope, healing, and spiritual growth through the truth of God's Word,
          one conversation and one disciple at a time.
        </p>
      </section>

      {/* PROFILES */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-10 md:py-16 space-y-16 md:space-y-32">
        {PROFILES.map((p, i) => (
          <article key={i} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-start ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}>
            <div className="lg:col-span-5">
              <div className="relative">
                <img src={p.image} alt={p.name} className="w-full h-[560px] object-cover" />
                <div className="absolute -bottom-4 -right-4 lg:-right-8 px-6 py-3 text-xs uppercase tracking-[0.3em]" style={{ background: p.accent, color: "var(--bg-base)" }}>
                  {`0${i + 1}`} · {p.role}
                </div>
              </div>
            </div>
            <div className="lg:col-span-7 lg:pt-8">
              <h2 className="font-serif-display text-5xl lg:text-7xl tracking-[-0.04em] leading-[0.95]" style={{ color: "var(--ink)" }}>
                {p.name}<span style={{ color: p.accent }}>.</span>
              </h2>
              <div className="editorial-rule my-8" />
              <div className="space-y-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--ink-2)" }}>
                {p.bio.map((para, j) => <p key={j}>{para}</p>)}
              </div>
              <blockquote className="mt-10 pl-6 border-l-2 font-serif-display-italic text-2xl lg:text-3xl leading-snug" style={{ borderColor: p.accent, color: "var(--ink)" }}>
                "{p.quote}"
              </blockquote>
            </div>
          </article>
        ))}
      </section>

      {/* CREED */}
      <section style={{ background: "var(--bg-alt)" }} className="mt-32">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 py-12 md:py-24">
          <div className="overline mb-3">What we believe</div>
          <h2 className="font-serif-display text-4xl md:text-6xl tracking-[-0.03em]" style={{ color: "var(--ink)" }}>
            A short, honest creed.
          </h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              { t: "Scripture is enough", b: "The Bible is the inspired Word of God — sufficient, authoritative, and worth a lifetime of reading slowly." },
              { t: "Discipleship is daily", b: "Following Jesus is not an event but a long obedience in the same direction." },
              { t: "The local church matters", b: "We write for the church, not around it. Real life happens in real congregations." },
            ].map((c, i) => (
              <div key={i} className="border-t pt-5" style={{ borderColor: "var(--ember)" }}>
                <div className="text-xs uppercase tracking-[0.2em] mb-3" style={{ color: "var(--ember)" }}>0{i + 1}</div>
                <h3 className="font-serif-display text-2xl tracking-tight leading-tight" style={{ color: "var(--ink)" }}>{c.t}</h3>
                <p className="mt-3 leading-relaxed" style={{ color: "var(--ink-2)" }}>{c.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
